export const MODES = {
  INVITEE: "MODES.INVITEE",
  INVITER: "MODES.INVITER"
};
